import { render, staticRenderFns } from "./carMessage.vue?vue&type=template&id=1275ba75&scoped=true&"
import script from "./carMessage.vue?vue&type=script&lang=js&"
export * from "./carMessage.vue?vue&type=script&lang=js&"
import style0 from "./carMessage.vue?vue&type=style&index=0&id=1275ba75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1275ba75",
  null
  
)

export default component.exports